export { default as CourseAccessItem } from './CourseAccessItem';
